import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  iso: {
    width: 87,
    height: 56,
  },

  license: {
    color: '#414141',
    textAlign: 'left',
  },

  footer: {
    '& a': {
      fontSize: 14,
      lineHeight: '18px',
      color: '#1F2121',
    },

    '& *': {
      borderRight: 'none',
      borderTop: 'none',
    },
  },

  globalFooterWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center !important',
    flexWrap: 'nowrap',
    margin: '13px 0px',

    '& .MuiGrid-container': {
      backgroundColor: 'transparent',
      padding: '0px 0px 0px 24px',
    },
    '& .MuiGrid-item': {
      flexBasis: 'auto',
      maxWidth: 'none',
      color: '#1F2121',
      fontSize: '12px',
      padding: '0px 32px 0px 0px',
    },
  },

  logoRow: {
    backgroundColor: '#FFFFFF',
    padding: '25px 28px 20px',
    margin: 0,
    border: 'none',
    boxShadow: 'none',
    outline: 'none',
    fontSize: '14px',
  },

  paragraph: {
    lineHeight: '1.5',
    fontSize: '1.2em',
  },

  twoColumnLayout: {
    display: 'flex',
    gap: '48px',

    '& > div': {
      flex: 1,
    },
  },

  bottomFooterLinks: {
    margin: '0px 0px 0px 0px !important',
    padding: '0px 8px 0px 8px',
    '& a': {
      fontSize: '12px',
      color: '#1F2121',
      textDecoration: 'none',
    },
  },
}));
